export default "__VITE_ASSET__D9U9TMIr__"